import $ from 'jquery';
import ToggleButton from './parts/ToggleButton';
import Toolbar from './parts/Toolbar';
import KeyboardNav from './parts/KeyboardNav'
import {EVENT_TOGGLE_TOOLBAR,EVENT_ON_ACC_READY,EVENT_HIDE_ACC} from './Params';
import {actions} from './Actions';
import {state} from './State';
import {isEmpty,register_outline_toggle,load_recaptcha} from "./Helpers"

/*todo:
*zoom action fix
*locales!
*/
class Acc{
    constructor(){
        this._data ={};
        this.isOpen = false;
        this.state=state;
        this.init();
    }
    get isOpen(){ return this._data.isOpen}
    set isOpen(x){ this._data.isOpen = x }

    init() {
        this.elem = $('#acc-toolbar-wrap');
        this.toolbar = new Toolbar();
        this.mainbtn = new ToggleButton();
        this.keybord_nav =  new KeyboardNav();
        this.actions = actions;



        $(document).on(EVENT_ON_ACC_READY,()=>actions.onPageLoad())
        $(document).on(EVENT_TOGGLE_TOOLBAR,(e,x)=>actions.onTogglePanel(x))
        $(document).on(EVENT_HIDE_ACC,(e,x)=>actions.onHideAcc())

        register_outline_toggle();
        this.elem.append(this.mainbtn.render(),this.toolbar.render())
        this.elem.prependTo($('body'));
        $('body').addClass('acc-active');
        load_recaptcha();

    };


}

$(()=>{
    if(isEmpty(window.acc)){
        console.log('acc not loaded')
        return
    }
    window.acc = Object.assign({}, window['acc'] || {})
    window.acc['root'] = new Acc();
    console.log('.acc.');
    $(document).trigger(EVENT_ON_ACC_READY)
});


